module.exports = __webpack_public_path__ + "img/express.6dd87484.png";